import { v4 as uuid } from 'uuid';

import { IPatient, v2, constants } from '../../..';
import { personJobStatusAdapter } from './personJobStatus.adapter';
import { getDefaults } from './helpers/getDefaults';
import { getHcpAttributes } from './helpers/getHcpAttributes';

export const personJobAdapter = (job: IPatient): v2.PersonJob[] => {
    const { staffRequired } = job;

    const defaults = getDefaults(job as IPatient);

    const personJobCount = staffRequired || 1;
    const personJobs: v2.PersonJob[] = [];

    Array.from({ length: personJobCount }).forEach((_, index) => {
        const isBuddy = index === 1;
        const { hcpId, hcpName } = getHcpAttributes(job, { isBuddy });
        const personJobStatuses = personJobStatusAdapter(job, { isBuddy });

        const personJob: v2.PersonJob = {
            ...defaults,
            id: uuid(),
            jobId: constants.NOT_CAPTURED,
            personId: null,
            currentJobStatusName: personJobStatuses?.[0]?.jobTypeStatusId,
            personJobStatuses,
        };

        if (hcpId) {
            const nameParts = hcpName?.split(' ') || [];
            personJob.person = {
                ...defaults,
                id: hcpId,
                firstName: nameParts.at(0) || '',
                lastName: nameParts.at(-1) || '',
                genderId: constants.NOT_CAPTURED,
            };
            if (nameParts.length > 2) {
                personJob.person.middleName = nameParts.slice(1, -1).join(' ');
            }
            personJob.personId = hcpId;
        }

        personJobs.push(personJob);
    });

    return personJobs;
};
